<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_1478)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_1478)" />
    </g>
    <path
      d="M13.5 12C12.837 12 12.2011 12.2634 11.7322 12.7322C11.2634 13.2011 11 13.837 11 14.5V21.5C11 22.163 11.2634 22.7989 11.7322 23.2678C12.2011 23.7366 12.837 24 13.5 24H20.5C21.163 24 21.7989 23.7366 22.2678 23.2678C22.7366 22.7989 23 22.163 23 21.5V14.5C23 13.837 22.7366 13.2011 22.2678 12.7322C21.7989 12.2634 21.163 12 20.5 12H13.5ZM12 14.5C12 14.1022 12.158 13.7206 12.4393 13.4393C12.7206 13.158 13.1022 13 13.5 13H20.5C20.8978 13 21.2794 13.158 21.5607 13.4393C21.842 13.7206 22 14.1022 22 14.5V21.5C22 21.8978 21.842 22.2794 21.5607 22.5607C21.2794 22.842 20.8978 23 20.5 23H13.5C13.1022 23 12.7206 22.842 12.4393 22.5607C12.158 22.2794 12 21.8978 12 21.5V14.5ZM19.854 16.854C19.9479 16.7601 20.0006 16.6328 20.0006 16.5C20.0006 16.3672 19.9479 16.2399 19.854 16.146C19.7601 16.0521 19.6328 15.9994 19.5 15.9994C19.3672 15.9994 19.2399 16.0521 19.146 16.146L16 19.293L14.854 18.146C14.7601 18.0521 14.6328 17.9994 14.5 17.9994C14.3672 17.9994 14.2399 18.0521 14.146 18.146C14.0521 18.2399 13.9994 18.3672 13.9994 18.5C13.9994 18.6328 14.0521 18.7601 14.146 18.854L15.646 20.354C15.6924 20.4006 15.7476 20.4375 15.8084 20.4627C15.8691 20.4879 15.9342 20.5009 16 20.5009C16.0658 20.5009 16.1309 20.4879 16.1916 20.4627C16.2524 20.4375 16.3076 20.4006 16.354 20.354L19.854 16.854Z"
      fill="white" />
    <defs>
      <filter id="filter0_d_3254_1478"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.380078 0 0 0 0 0.0313726 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_1478" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_1478" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_1478"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF6108" />
        <stop offset="1" stop-color="#FF6F42" />
      </linearGradient>
    </defs>
  </svg>
</template>
